export default __webpack_public_path__ + "static/media/spider_man_brooklyn_bridge.f77982d7.jpg";